<div class="container my-3">
    <div class="row justify-content-center align-items-center">
      <div class="col-auto">
        <button
          class="btn btn-primary"
          [class.selected]="selectedButton === 'salesreport'"
          (click)="selectedButton = 'salesreport'"
          routerLink="/dashboard/reports/salesreport">
          Sales Report
        </button>
      </div>
      <div class="col-auto">
        <button
          class="btn btn-primary"
          [class.selected]="selectedButton === 'ordersreport'"
          (click)="selectedButton = 'ordersreport'"
          routerLink="/dashboard/reports/ordersreport">
          Order Report
        </button>
      </div>
      <div class="col-auto">
        <button
          class="btn btn-primary"
          [class.selected]="selectedButton === 'companyreport'"
            (click)="selectedButton = 'companyreport'"
          routerLink="/dashboard/reports/companyreport">
          Company Report
        </button>
      </div>
      <div class="col-auto">
        <a
          class="btn btn-primary"
          [class.selected]="selectedButton === 'planner'"
            (click)="selectedButton = 'planner'"
          routerLink="/dashboard/reports/planner">
          Svinn Report
        </a>
      </div>
    </div>
  </div>
  <router-outlet></router-outlet>
